(()=>{
  const roots=()=>[...document.querySelectorAll('[data-mm-browse]')];
  const drawers=()=>[...document.querySelectorAll('[data-mm-nav-menu]')];
  const close=(node,focus=false)=>{node.open=false;if(focus)node.querySelector(':scope > summary')?.focus();};
  document.addEventListener('click',event=>{
    [...roots(),...drawers()].forEach(menu=>{if(!menu.contains(event.target))close(menu);});
    const link=event.target.closest('.mm-tree-panel a,.mm-all-bracelets');
    if(link){[...roots(),...drawers()].forEach(menu=>close(menu));}
  });
  document.addEventListener('toggle',event=>{
    const menu=event.target;if(!(menu instanceof HTMLDetailsElement)||!menu.open)return;
    if(menu.matches('[data-mm-browse]')){
      const nav=menu.closest('nav');roots().filter(other=>other!==menu&&other.closest('nav')===nav).forEach(other=>close(other));
    }else if(menu.matches('[data-mm-tree-branch]')){
      const list=menu.closest('ul');if(list)[...list.children].forEach(li=>{const peer=li.querySelector(':scope > details[data-mm-tree-branch]');if(peer&&peer!==menu)close(peer);});
    }
  },true);
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    const target=event.target.closest('.mm-tree-branch[open],.mm-tree-menu[open],[data-mm-nav-menu][open]');
    if(target){event.preventDefault();event.stopPropagation();close(target,true);}
  });
  const path=location.pathname.replace(/\/$/,'');
  document.querySelectorAll('.mm-tree-panel a').forEach(link=>{if(new URL(link.href,location.origin).pathname===path)link.setAttribute('aria-current','page');});
  matchMedia('(max-width:1100px)').addEventListener('change',()=>[...roots(),...drawers()].forEach(menu=>close(menu)));
})();
